import React from "react";
import { t } from "i18next";

import { PriceProps } from "@models/components/user.model";

const Price: React.FC<PriceProps> = ({
  customClass = "",
  label,
  labelClass,
  recursiveBooking,
  subLabel,
  value,
}) => {
  return (
    <div className={`row ${customClass}`}>
      <div className="col-7">
        <h5 className={labelClass || ""} data-testid="price-label">
          {label}
          {subLabel && (
            <span data-testid="price-sub-label">{` (${subLabel})`}</span>
          )}
        </h5>
      </div>
      <div className="col-5 text-end">
        {recursiveBooking ? (
          <span className="loc-type ms-2">{t("recurring")}</span>
        ) : (
          <h5 data-testid="price-text">{value || "-"}</h5>
        )}
      </div>
    </div>
  );
};

export default Price;
